import { render, staticRenderFns } from "./ActualFeeRateResource.vue?vue&type=template&id=1607db9b&"
import script from "./ActualFeeRateResource.vue?vue&type=script&lang=js&"
export * from "./ActualFeeRateResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports